import { render, staticRenderFns } from "./ShowCategories.vue?vue&type=template&id=3a0c14c0&scoped=true&"
import script from "./ShowCategories.vue?vue&type=script&lang=js&"
export * from "./ShowCategories.vue?vue&type=script&lang=js&"
import style0 from "./ShowCategories.vue?vue&type=style&index=0&id=3a0c14c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0c14c0",
  null
  
)

export default component.exports